var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 72.1654C57.489 72.1654 71.6667 57.9877 71.6667 40.4987C71.6667 23.0097 57.489 8.83203 40 8.83203C22.511 8.83203 8.33334 23.0097 8.33334 40.4987C8.33334 57.9877 22.511 72.1654 40 72.1654Z",
    fill: "url(#paint0_linear_753_4192)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 10.4344C23.3946 10.4344 9.93334 23.8957 9.93334 40.501C9.93334 57.1064 23.3946 70.5677 40 70.5677C56.6054 70.5677 70.0667 57.1064 70.0667 40.501C70.0667 23.8957 56.6054 10.4344 40 10.4344ZM6.73334 40.501C6.73334 22.1284 21.6273 7.23438 40 7.23438C58.3727 7.23438 73.2667 22.1284 73.2667 40.501C73.2667 58.8737 58.3727 73.7677 40 73.7677C21.6273 73.7677 6.73334 58.8737 6.73334 40.501Z",
    fill: "url(#paint1_linear_753_4192)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 55.0164C40.6535 55.0164 41.1833 54.4866 41.1833 53.8331C41.1833 53.1795 40.6535 52.6497 40 52.6497C39.3465 52.6497 38.8167 53.1795 38.8167 53.8331C38.8167 54.4866 39.3465 55.0164 40 55.0164ZM37.9833 53.8331C37.9833 52.7193 38.8862 51.8164 40 51.8164C41.1138 51.8164 42.0167 52.7193 42.0167 53.8331C42.0167 54.9468 41.1138 55.8497 40 55.8497C38.8862 55.8497 37.9833 54.9468 37.9833 53.8331Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56.3497C41.3899 56.3497 42.5167 55.223 42.5167 53.8331C42.5167 52.4432 41.3899 51.3164 40 51.3164C38.6101 51.3164 37.4833 52.4432 37.4833 53.8331C37.4833 55.223 38.6101 56.3497 40 56.3497Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 53.1497C39.6226 53.1497 39.3167 53.4557 39.3167 53.8331C39.3167 54.2105 39.6226 54.5164 40 54.5164C40.3774 54.5164 40.6833 54.2105 40.6833 53.8331C40.6833 53.4557 40.3774 53.1497 40 53.1497ZM42.5167 53.8331C42.5167 55.223 41.3899 56.3497 40 56.3497C38.6101 56.3497 37.4833 55.223 37.4833 53.8331C37.4833 52.4432 38.6101 51.3164 40 51.3164C41.3899 51.3164 42.5167 52.4432 42.5167 53.8331Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9999 54.5984C40.4233 54.5984 40.7666 54.2552 40.7666 53.8318C40.7666 53.4083 40.4233 53.0651 39.9999 53.0651C39.5765 53.0651 39.2333 53.4083 39.2333 53.8318C39.2333 54.2552 39.5765 54.5984 39.9999 54.5984ZM37.5666 53.8318C37.5666 52.4879 38.656 51.3984 39.9999 51.3984C41.3438 51.3984 42.4333 52.4879 42.4333 53.8318C42.4333 55.1757 41.3438 56.2651 39.9999 56.2651C38.656 56.2651 37.5666 55.1757 37.5666 53.8318Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 23.8984C40.8836 23.8984 41.6 24.6148 41.6 25.4984V45.7068C41.6 46.5904 40.8836 47.3068 40 47.3068C39.1163 47.3068 38.4 46.5904 38.4 45.7068V25.4984C38.4 24.6148 39.1163 23.8984 40 23.8984Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_753_4192",
    x1: 16.4292,
    y1: 64.0695,
    x2: 73.3333,
    y2: 7.16536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#780202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F50000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_753_4192",
    x1: 15.2382,
    y1: 65.2628,
    x2: 75.0175,
    y2: 5.4835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#780202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F50000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.a50184417d44eb0c6f4fd3d3d6bd868a.svg";
export { ForwardRef as ReactComponent };